// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"449":"6617910a","470":"2a7236ca","548":"6617910a","712":"049d8d4b","779":"557078cb"}[chunkId] + ".chunk.css";
};